module.exports = __webpack_public_path__ + "img/icon_delegate.00265487.png";